import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=532ae6c1&scoped=true"
import script from "./BaseInfo.vue?vue&type=script&lang=js"
export * from "./BaseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ae6c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532ae6c1')) {
      api.createRecord('532ae6c1', component.options)
    } else {
      api.reload('532ae6c1', component.options)
    }
    module.hot.accept("./BaseInfo.vue?vue&type=template&id=532ae6c1&scoped=true", function () {
      api.rerender('532ae6c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeDetails/components/BaseInfo.vue"
export default component.exports